import styled from 'styled-components'

export const FilterBlock = styled.div`
  margin: 1rem 0;
`
